import React from 'react';
import { Typography, RadioGroup, FormControlLabel, Radio, SxProps, TypographyVariant } from '@mui/material';

interface RadioGroupBoxProps {
    label: string;
    labelSize?: TypographyVariant;
    name: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    options: { value: string; label: string }[];
    row?: boolean;
    sx?: SxProps;
    required?: boolean; // 新增 required 屬性
}

const RadioGroupBox: React.FC<RadioGroupBoxProps> = ({
    label,
    labelSize = 'h6',
    name,
    value,
    onChange,
    options,
    row = true,
    sx = {},
    required = false, // 默認值為 false
}) => (
    <>
        <Typography variant={labelSize} align="left" gutterBottom>
            {label}
            {required && <span style={{ color: 'red' }}>*</span>} {/* 顯示必填標記 */}
        </Typography>
        <RadioGroup name={name} value={value} onChange={onChange} row={row} sx={sx}>
            {options.map((option) => (
                <FormControlLabel
                    key={option.value}
                    value={option.value}
                    control={
                        <Radio
                            sx={{
                                '&.Mui-checked': {
                                    color: 'var(--primary-blue)',
                                },
                            }}
                        />
                    }
                    label={option.label}
                />
            ))}
        </RadioGroup>
    </>
);

export default RadioGroupBox;
